import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { Syndicat } from "../../lib/interfaces/syndicat.interface";
import axiosClient from "../../lib/axiosClient";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { toast } from "sonner";
import { AtSign, Phone, Search } from "lucide-react";

const TrouverSyndicatButton = () => {
  const [parent] = useAutoAnimate();
  const [departement, setDepartement] = useState("");
  const [syndicats, setSyndicats] = useState<Syndicat[] | null>(null);
  const { isPending, mutate: rechercher } = useMutation({
    mutationFn: async (dpt: string) => {
      const { data } = await axiosClient.get<Syndicat[]>(
        `/syndicats/affilies/?departement=${dpt}`
      );
      return data;
    },
    onSuccess: (data) => {
      setSyndicats(data);
    },
    onError: () => {
      toast.error("Une erreur s'est produite.");
    },
  });

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant={"outline"} icon={<Search className="w-4 h-4" />}>
          Trouver un syndicat proche
        </Button>
      </DialogTrigger>

      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Trouver un syndicat</DialogTitle>
          <DialogDescription>
            Pour trouver un syndicat affilié au SNA proche de chez vous,
            veuillez renseigner un numéro de département.
          </DialogDescription>
        </DialogHeader>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            rechercher(departement);
          }}
        >
          <div>
            <Label htmlFor="dpt" className="text-right">
              N° de département
            </Label>
            <Input
              className="mt-0.5"
              required
              id="dpt"
              value={departement}
              onChange={(e) => setDepartement(e.currentTarget.value)}
            />
          </div>
          <div className="mt-6 text-right">
            <Button loading={isPending} type="submit">
              Rechercher
            </Button>
          </div>
        </form>

        {/* Aucun résultats */}
        {!!syndicats && syndicats.length === 0 && (
          <div>Pas de résultats pour ce département.</div>
        )}

        {/* Liste des résultats */}
        <div className="flex flex-col gap-3" ref={parent}>
          {!!syndicats && syndicats.length > 0 && (
            <>
              <div className="font-semibold">
                Résultats pour {departement} :
              </div>
              {syndicats.map((syndicat) => (
                <div
                  className="border-l-2 border-slate-700 pl-4"
                  key={syndicat.id}
                >
                  <div className="font-medium">{syndicat.nom}</div>
                  <div className="flex flex-row gap-4 mt-2 items-center">
                    <Phone className="h-4 w-4" />
                    <div>{syndicat.telephone || "-"}</div>
                  </div>
                  <div className="flex flex-row gap-4 mt-0.5 items-center">
                    <AtSign className="h-4 w-4" />
                    <div>{syndicat.email || "-"}</div>
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TrouverSyndicatButton;
